import { useT, type ViewMode } from "@reciperoll/core";
import { Grid, List } from "react-feather";

// Grid/list toggle. Presentational — the caller owns the mode (persisted in the
// preferences slice).
export function RecipeViewSwitcher({
  viewMode,
  onSwitch,
}: {
  viewMode: ViewMode;
  onSwitch: (mode: ViewMode) => void;
}) {
  const t = useT();
  const btn = (active: boolean) =>
    `w-9 h-9 flex items-center justify-center cursor-pointer transition-colors ${
      active ? "bg-surface-2" : "bg-surface hover:bg-surface-2"
    }`;
  const icon = (active: boolean) => `w-4 h-4 ${active ? "text-terracotta" : "text-ink-faint"}`;

  return (
    <div className="flex bg-surface border border-line rounded-lg overflow-hidden">
      <button
        type="button"
        aria-label={t("library.gridView")}
        aria-pressed={viewMode === "grid"}
        onClick={() => onSwitch("grid")}
        className={btn(viewMode === "grid")}
      >
        <Grid className={icon(viewMode === "grid")} />
      </button>
      <button
        type="button"
        aria-label={t("library.listView")}
        aria-pressed={viewMode === "list"}
        onClick={() => onSwitch("list")}
        className={btn(viewMode === "list")}
      >
        <List className={icon(viewMode === "list")} />
      </button>
    </div>
  );
}
